define('app/translations.js',[], function() { 
    function translations($translateProvider) {

		$translateProvider.translations('en', {
            'TITLE': 'European Causes of Death',
            'DESCRIPTION': 'We\'ve gathered mortality data from countries around Europe as to the top causes of death and average life expectancy. Tell us your gender, country of residence, and age to learn more.',
            'SUBTITLE': 'How Might You Die?',
            'GENDER_TEXT': 'I\'m a',
            'MALE': 'Male',
            'FEMALE': 'Female',
            'GEO_TEXT': 'I live in',
            'GEO_SELECT': 'Select your home country',
            'AGE_TEXT': 'My age:',
            'CAUSE_TAGLINE': '{{cause}} is the most likely way.',
            'RESULTS_LIFE': 'General Life expectancy for a {{selectedGender}} age {{selectedAge}} in {{selectedCountry}}: <span>0</span> years',
            'EURO_LIFE': 'European avg: {{euroLife}} years',
            'GENERAL_LIFE': 'General Life expectancy: {{life}} years',
            'RESULTS_CAUSES': 'The top causes of death for {{selectedGender}} in {{selectedCountry}} are',
            'GENERAL_CAUSES': 'The top causes of death',
            'COUNTRY_FILTER': 'Filter by country',
            'SLIDES': '{{active}} of {{slides}}',
            'BACK': 'back',
            'NEXT': 'next',
            'AGAIN': 'start again',
            'YOUR_BUTTON': 'Your home country',
            'EUROPE_BUTTON': 'Around Europe',
            'CLEAR': 'Clear Selections',
        });

        $translateProvider.translations('fr', {
            'TITLE': 'Causes de décès en Europe',
            'DESCRIPTION': 'Nous avons rassemblé les données sur la mortalité à travers l\'Europe dont les principales causes de décès et l\'espérance de vie. Indiquez si vous êtes un homme ou une femme, le pays où vous vivez et votre âge pour accéder à plus d\'informations.',
            'SUBTITLE': 'De quoi risquez-vous de mourir ?',
            'GENDER_TEXT': 'Je suis',
            'MALE': 'un homme',
            'FEMALE': 'une femme',
            'GEO_TEXT': 'Je vis',
            'GEO_SELECT': 'Sélectionnez votre pays de résidence',
            'AGE_TEXT': 'Mon âge :',
            'CAUSE_TAGLINE': '{{cause}} est la cause la plus probable.',
            'RESULTS_LIFE': 'L\'espérance de vie moyenne pour vous qui avez {{selectedAge}} dans votre pays : <span>0</span> ans',
            'EURO_LIFE': 'Moyenne européenne : {{euroLife}} ans',
            'GENERAL_LIFE': 'Espérance de vie moyenne: {{life}} ans',
            'RESULTS_CAUSES': 'Les principales causes de décès pour {{selectedGender}} {{selectedCountry}} sont',
            'GENERAL_CAUSES': 'Les principales causes de décès',
            'COUNTRY_FILTER': 'Afficher par pays',
            'SLIDES': '{{active}} de {{slides}}',
            'BACK': 'Retour',
            'NEXT': 'Suite',
            'AGAIN': 'Recommencez',
            'YOUR_BUTTON': 'Votre pays de résidence',
            'EUROPE_BUTTON': 'En Europe',
            'CLEAR': 'Effacer la sélection',
        });

        $translateProvider.translations('de', {
            'TITLE': 'Todesursachen in Europa',
            'DESCRIPTION': 'Wir haben Sterblichkeitsdaten aus Ländern in ganz Europa zusammengestellt, darunter die Haupttodesuraschen und die durchschnittliche Lebenserwartung. Nennen Sie uns Ihr Geschlecht, ihren Wohnort und Ihr Alter, um mehr zu erfahren.',
            'SUBTITLE': 'Was befürchten Sie für sich selbst am ehesten als Todesursache?',
            'GENDER_TEXT': 'Ich bin',
            'MALE': 'ein Mann',
            'FEMALE': 'eine Frau',
            'GEO_TEXT': 'Ich lebe in',
            'GEO_SELECT': 'Wählen Sie das Land Ihres Wohnsitzes',
            'AGE_TEXT': 'Mein Alter:',
            'CAUSE_TAGLINE': '{{cause}} ist die wahrscheinlichste Ursache.',
            'RESULTS_LIFE': 'Durchschnittliche Lebenserwartung für eine/n  {{selectedGender}} im Alter von {{selectedAge}} in {{selectedCountry}}: <span>0</span> Jahre ',
            'EURO_LIFE': 'Europäischer Durchschnitt: {{euroLife}} Jahre',
            'GENERAL_LIFE': 'Durchschnittliche Lebenserwartung: {{life}} Jahre',
            'RESULTS_CAUSES': 'Die Haupttodesursachen für eine/n {{gender}} in {{selectedCountry}} sind',
            'GENERAL_CAUSES': 'Die Hauptdodesursachen',
            'COUNTRY_FILTER': 'unterteilt nach Ländern',
            'SLIDES': '{{active}} von {{slides}}',
            'BACK': 'zurück',
            'NEXT': 'nächste',
            'AGAIN': 'neu starten',
            'YOUR_BUTTON': 'Ihr Land',
            'EUROPE_BUTTON': 'in Europa',
            'CLEAR': 'Auswahl löschen',
        });

        $translateProvider.translations('ua', {
            'TITLE': 'Причини смерті в Європі',
            'DESCRIPTION': 'Ми зібрали дані з усіх країн Європи щодо найбільш поширених причин смерті та середньої тривалості життя. Повідомте нам Вашу стать, країну проживання та вік, щоб дізнатися більше',
            'SUBTITLE': 'Від чого Ви можете померти?',
            'GENDER_TEXT': 'Я',
            'MALE': 'чоловік',
            'FEMALE': 'жінка',
            'GEO_TEXT': 'живу в',
            'GEO_SELECT': 'Оберіть Вашу країну',
            'AGE_TEXT': 'Мій вік:',
            'CAUSE_TAGLINE': '{{cause}} найбільш вірогідна причина смерті.',
            'RESULTS_LIFE': 'Середня тривалість життя для {{selectedGender}} вік {{selectedAge}} у {{selectedCountry}}: <span>0</span> років',
            'EURO_LIFE': 'В середньому по Європі: {{euroLife}} років',
            'GENERAL_LIFE': 'Середня тривалість життя: {{life}} років',
            'RESULTS_CAUSES': 'Найвірогідніші причини смерті для {{gender}} у {{selectedCountry}}:',
            'GENERAL_CAUSES': 'Найпоширеніші причини смерті',
            'COUNTRY_FILTER': 'Обрати за країною',
            'SLIDES': '{{active}} з {{slides}}',
            'BACK': 'Назад',
            'NEXT': 'Вперед',
            'AGAIN': 'Почати знову',
            'YOUR_BUTTON': 'Карїна',
            'EUROPE_BUTTON': 'У Європі',
            'CLEAR': 'Змінити параметри пошуку',
        });

        $translateProvider.translations('it', {
            'TITLE': 'European Causes of Death',
            'DESCRIPTION': 'Abbiamo raccolto i dati di mortalità provenienti dai paesi europei circa le principali cause di morte e di vita. Raccontaci la tua storia, se sei uomo o donna, indaca il tuo paese di residenza, e l\'età per avere maggiori info.',
            'SUBTITLE': 'Cause di morte',
            'GENDER_TEXT': 'Io sono',
            'MALE': 'Uomo',
            'FEMALE': 'Donna',
            'GEO_TEXT': 'Risiedo',
            'GEO_SELECT': 'Seleziona il tuo paese di residenza',
            'AGE_TEXT': 'Età:',
            'CAUSE_TAGLINE': '{{cause}} la causa più probabile.',
            'RESULTS_LIFE': 'Aspettativa generale di vita {{selectedGender}} età {{selectedAge}} in {{selectedCountry}}: <span>0</span> anni',
            'EURO_LIFE': 'Media Europea: {{euroLife}} anni',
            'GENERAL_LIFE': 'Aspettative di vita: {{life}} anni',
            'RESULTS_CAUSES': 'Le principali cause di morte {{gender}} in {{selectedCountry}} sono',
            'GENERAL_CAUSES': 'Le principali cause di morte',
            'COUNTRY_FILTER': 'Scegli per Paese',
            'SLIDES': '{{active}} di {{slides}}',
            'BACK': 'Indietro',
            'NEXT': 'Avanti',
            'AGAIN': 'Ricomincia',
            'YOUR_BUTTON': 'Paese',
            'EUROPE_BUTTON': 'In Europa',
            'CLEAR': 'Cancella la selezione',
        });

        $translateProvider.translations('ru', {
            'TITLE': 'Причины смертности в Европе',
            'DESCRIPTION': 'Мы собрали данные о причинах смертности и средней продолжительности жизни в Европе. Чтобы узнать больше, укажите вашу страну, возраст и пол.',
            'SUBTITLE': 'От чего вы рискуете умереть',
            'GENDER_TEXT': 'Я',
            'MALE': 'мужчина',
            'FEMALE': 'женщина',
            'GEO_TEXT': 'Я живу в',
            'GEO_SELECT': 'Выберите вашу страну',
            'AGE_TEXT': 'Мой возраст:',
            'CAUSE_TAGLINE': '{{cause}} наиболее вероятная причина',
            'RESULTS_LIFE': 'При выбранных вами параметрах средняя продолжительность жизни: <span>0</span> лет',
            'EURO_LIFE': 'В среднем по Европе: {{euroLife}} лет',
            'GENERAL_LIFE': 'Продолжительность жизни: {{life}} лет',
            'RESULTS_CAUSES': 'Основные причины смертности для вашего пола в вашей стране:',
            'GENERAL_CAUSES': 'Основные причины смертности',
            'COUNTRY_FILTER': 'Выбрать по странам',
            'SLIDES': '{{active}} из {{slides}}',
            'BACK': 'Назад',
            'NEXT': 'Вперед',
            'AGAIN': 'Начать снова',
            'YOUR_BUTTON': 'Ваша страна',
            'EUROPE_BUTTON': 'В Европе',
            'CLEAR': 'Отменить параметры поиска',
        });

        $translateProvider.translations('es', {
            'TITLE': 'Causas de muerte en Europa',
            'DESCRIPTION': 'Hemos recopilado los datos sobre las principales causas de muerte y de esperanza de vida en Europa. Indíquenos su género, país de residencia y edad para saber más.',
            'SUBTITLE': '¿De qué podría morir?',
            'GENDER_TEXT': 'Soy',
            'MALE': 'Hombre',
            'FEMALE': 'Mujer',
            'GEO_TEXT': 'Vivo en',
            'GEO_SELECT': 'Seleccione su país de reisdencia',
            'AGE_TEXT': 'Edad:',
            'CAUSE_TAGLINE': '{{cause}} es la causa más probable',
            'RESULTS_LIFE': 'Esperanza media de vida para {{Gender}}, de {{Age}} años, en {{Country}}: <span>0</span> años',
            'EURO_LIFE': 'Media europea: {{euroLife}} años',
            'GENERAL_LIFE': 'Esperanza media de vida: {{life}} años',
            'RESULTS_CAUSES': 'Las principales causas de muerte para {{gender}} en {{selectedCountry}} son',
            'GENERAL_CAUSES': 'Las principales causas de muerte',
            'COUNTRY_FILTER': 'Mostrar por país',
            'SLIDES': '{{active}} de {{slides}}',
            'BACK': 'Volver',
            'NEXT': 'Siguiente',
            'AGAIN': 'Volver a empezar',
            'YOUR_BUTTON': 'País de residencia',
            'EUROPE_BUTTON': 'En Europa',
            'CLEAR': 'Borrar selección',
        });

        $translateProvider.translations('pt', {
            'TITLE': 'Causas de morte na Europa',
            'DESCRIPTION': 'Recolhemos (Agregamos) todos os dados sobre as principais causas de morte e esperança de vida na Europa. Indique-nos se é homem ou mulher, o país em que vive e a sua idade para ter acesso a mais informações.',
            'SUBTITLE': 'Principal risco de morte',
            'GENDER_TEXT': 'Sou',
            'MALE': 'um homem',
            'FEMALE': 'uma mulher',
            'GEO_TEXT': 'Vivo em',
            'GEO_SELECT': 'Selecione o país',
            'AGE_TEXT': 'Idade:',
            'CAUSE_TAGLINE': 'A causa mais provável será {{cause}}.',
            'RESULTS_LIFE': 'Esperança média de vida para {{Gender}}, de {{Age}} anos, em {{Country}}: <span>0</span> anos',
            'EURO_LIFE': 'Média europeia: {{euroLife}} anos',
            'GENERAL_LIFE': 'Esperança média de vida: {{life}} anos',
            'RESULTS_CAUSES': 'As principais causas de morte para {{gender}} em {{selectedCountry}} são',
            'GENERAL_CAUSES': 'As principais causas de morte',
            'COUNTRY_FILTER': 'Mostrar por país',
            'SLIDES': '{{active}} de {{slides}}',
            'BACK': 'Para trás',
            'NEXT': 'Avançar',
            'AGAIN': 'Recomeçar',
            'YOUR_BUTTON': 'O seu país',
            'EUROPE_BUTTON': 'Na Europa',
            'CLEAR': 'Apagar filtros',
        });

        $translateProvider.translations('pe', {
            'TITLE': 'دلایل مرگ در اروپا',
            'DESCRIPTION': 'داده های آماری درباره مرگ و میر و امید به زندگی در کشورهای اروپایی را جمع آوری کرده ایم. برای دریافت اطلاعات بیشتر، جنسیت و کشور محل زندگی خود را انتخاب کنید  ',
            'SUBTITLE': 'دلیل مرگ شما به احتمال زیاد چه خواهد بود؟ ',
            'GENDER_TEXT': 'جنسیت من ',
            'MALE': 'مرد ',
            'FEMALE': 'زن',
            'GEO_TEXT': 'زندگی می کنم در',
            'GEO_SELECT': 'کشور محل زندگی ',
            'AGE_TEXT': 'سن من ',
            'CAUSE_TAGLINE': ' محمتل ترین دلیل است ' + '{{cause}}',
            'RESULTS_LIFE': '<span>0</span> ' + 'سال' + ' {{selectedCountry}} ' + 'در' + ' {{selectedAge}} ' + 'دارای' + ' {{selectedGender}} ' + 'امید به زندگی به طور میانگین برای یک',
            'EURO_LIFE': 'سال' + '{{euroLife}}' + 'میانگین سن افراد در اروپا',
            'GENERAL_LIFE': 'سال' + '{{life}}' + 'میزان امید به زندگی',
            'RESULTS_CAUSES': 'عبارت است از' + ' {{selectedCountry}} ' + 'در' + ' {{gender}} ' + 'دلیل اصلی مرگ',
            'GENERAL_CAUSES': 'دلیل اصلی مرگ ',
            'COUNTRY_FILTER': 'نمایش بر اساس کشور',
            'SLIDES': '{{active}} ' + 'از' + ' {{slides}}',
            'BACK': 'بازگشت',
            'NEXT': 'بعدی',
            'AGAIN': 'شروع دوباره',
            'YOUR_BUTTON': 'کشور محل زندگی شما',
            'EUROPE_BUTTON': 'در اروپا',
            'CLEAR': 'پاک کردن انتخابها',
        });

        $translateProvider.translations('gr', {
            'TITLE': 'Αιτίες Θανάτου στην Ευρώπη',
            'DESCRIPTION': 'Έχουμε συγκεντρώσει τα στοιχεία θνησιμότητας από χώρες της Ευρώπης αναφορικά με τις κυριότερες αιτίες θανάτου και το μέσο προσδόκιμο ζωής. Επιλέξτε το φύλο σας, τη χώρα διαμονής και την ηλικία σας για να μάθετε περισσότερα.',
            'SUBTITLE': 'Βασική αιτία θανάτου',
            'GENDER_TEXT': 'Είμαι',
            'MALE': 'άνδρας',
            'FEMALE': 'γυναίκα',
            'GEO_TEXT': 'Ζω στην',
            'GEO_SELECT': 'Επιλέξτε χώρα διαμονής',
            'AGE_TEXT': 'Η ηλικία μου:',
            'CAUSE_TAGLINE': '{{cause}} είναι η πιθανότερη αιτία',
            'RESULTS_LIFE': 'Γενικό προσδόκιμο ζωής για {{selectedGender}} ηλικίας {{selectedAge}} στην {{selectedCountry}}: <span>0</span> έτη',
            'EURO_LIFE': 'Ευρωπαϊκός μ.ο: {{eurolife}} έτη',
            'GENERAL_LIFE': 'Γενικό προσδόκιμο ζωής: {{life}} έτη',
            'RESULTS_CAUSES': 'Οι κύριες αιτίες θανάτου για {{gender}} στην {{selectedCountry}} είναι',
            'GENERAL_CAUSES': 'Οι κυριότερες αιτίες θανάτου',
            'COUNTRY_FILTER': 'Φίλτρο ανά χώρα',
            'SLIDES': '{{active}} από {{slides}}',
            'BACK': 'Πίσω',
            'NEXT': 'Επόμενο',
            'AGAIN': 'Ξεκινήστε πάλι',
            'YOUR_BUTTON': 'Η χώρα καταγωγής σας',
            'EUROPE_BUTTON': 'Στην Ευρώπη',
            'CLEAR': 'Αναίρεση επιλογών',
        });

        $translateProvider.translations('hu', {
            'TITLE': 'Halálozási okok Európában',
            'DESCRIPTION': 'Összegyűjtöttük Európa országainak halálozási adatait, köztük a leggyakoribb halálozási okokat, illetve az átlagos várható élettartamot. Adja meg nemét, lakhelyét és életkorát.',
            'SUBTITLE': 'Mi okozhatja a halálát?',
            'GENDER_TEXT': 'Neme:',
            'MALE': 'Férfi',
            'FEMALE': 'Nő',
            'GEO_TEXT': 'Itt él:',
            'GEO_SELECT': 'Válasszon országot!',
            'AGE_TEXT': 'Életkora:',
            'CAUSE_TAGLINE': 'A legvalószínűbb halálozási ok: {{cause}}',
            'RESULTS_LIFE': 'Várható élettartam: nem {{selectedGender}} életkor {{selectedAge}} ország {{selectedCountry}}: <span>0</span> év',
            'EURO_LIFE': 'Európai átlag: {{euroLife}} év',
            'GENERAL_LIFE': 'Átlagos várható élettartam: {{life}} év',
            'RESULTS_CAUSES': 'A leggyakoribb halálozási okok nem {{gender}} és ország {{selectedCountry}} szerint',
            'GENERAL_CAUSES': 'A leggyakoribb halálozási okok',
            'COUNTRY_FILTER': 'Országonként',
            'SLIDES': '{{active}} {{slides}} közül',
            'BACK': 'Vissza',
            'NEXT': 'Következő',
            'AGAIN': 'Újrakezdés',
            'YOUR_BUTTON': 'Az ön országa',
            'EUROPE_BUTTON': 'Európában',
            'CLEAR': 'A kiválasztott törlése',
        });

        $translateProvider.translations('tk', {
            'TITLE': 'Avrupa\'da ölüm nedenleri',
            'DESCRIPTION': 'Avrupa\'da sık görülen ölüm nedenleri ve ortalama yaşam süresi verilerini belirliyoruz. Ankete katılmak için lütfen cinsiyetinizi, yaşadığınız ülkeyi ve yaşınızı belirtin.',
            'SUBTITLE': 'Tahmini ölüm nedeniniz?',
            'GENDER_TEXT': 'Ben',
            'MALE': 'erkeğim',
            'FEMALE': 'kadınım',
            'GEO_TEXT': 'Yaşadığım yer',
            'GEO_SELECT': 'Ülkenizi seçin',
            'AGE_TEXT': 'Yaş:',
            'CAUSE_TAGLINE': 'en yüksek olasılık {{cause}}',
            'RESULTS_LIFE': '{{selectedGender}} ortalama yaşam süresi {{selectedAge}} yaş, {{selectedCountry}}: <span>0</span> yıl',
            'EURO_LIFE': 'Avrupa ortalaması: {{euroLife}} yıl',
            'GENERAL_LIFE': 'Ortalama yaşam süresi: {{life}} yıl',
            'RESULTS_CAUSES': '{{selectedCountry}}, {{gender}} için genel ölüm nedenleri ',
            'GENERAL_CAUSES': 'En çok gözlenen ölüm nedenleri',
            'COUNTRY_FILTER': 'Ülkeye göre',
            'SLIDES': '{{active}} {{slides}}',
            'BACK': 'Geri',
            'NEXT': 'İleri',
            'AGAIN': 'Yeniden başla',
            'YOUR_BUTTON': 'Ülkeniz',
            'EUROPE_BUTTON': 'Avrupa',
            'CLEAR': 'Seçimleri kaldır',
        });

        $translateProvider.translations('ar', {
            'TITLE': 'أسباب الوفاة في أوروبا',
            'DESCRIPTION': 'جمعنا بيانات عن الوفيات في جميع أنحاء أوروبا، والأسباب الرئيسية للوفاة ومتوسط العمر المتوقع. اذكر جنسك، والبلد الذي تعيش فيه وعمرك لجمع مزيد من المعلومات.',
            'SUBTITLE': 'السبب الأكثر احتمالاً للوفاة؟',
            'GENDER_TEXT': 'انا',
            'MALE': 'ذكر',
            'FEMALE': 'انثى',
            'GEO_TEXT': 'أعيش في',
            'GEO_SELECT': 'اختر البلد الذي تعيش فيه',
            'AGE_TEXT': 'العمر',
            'CAUSE_TAGLINE': 'السبب الأكثر احتمالا للموت' + ' {{cause}}',
            'RESULTS_LIFE': 'سنوات' + ' {{selectedCountry}}: <span>0</span> ' + 'في  بلدك' + ' {{selectedAge}} {{selectedGender}} ' + 'متوسط عمرك المتوقع',
            'EURO_LIFE': 'سنوات' + ' {{euroLife}} ' + 'متوسط الأعمار في أوروبا',
            'GENERAL_LIFE': 'سنوات' + ' {{life}} ' + 'العمرالعام المتوقع',
            'RESULTS_CAUSES': 'هي' + ' {{gender}} in {{selectedCountry}} ' + 'أهم أسباب الوفاة',
            'GENERAL_CAUSES': 'أهم أسباب الوفاة',
            'COUNTRY_FILTER': 'عرض حسب البلد',
            'SLIDES': '{{active}} ' + 'من' + ' {{slides}}',
            'BACK': 'عودة',
            'NEXT': 'تابع',
            'AGAIN': 'ابدأ مجدداً',
            'YOUR_BUTTON': 'بلد الإقامة',
            'EUROPE_BUTTON': 'في أوربا',
            'CLEAR': 'الغاء الإختيار',
        });
        
        $translateProvider.preferredLanguage('en');
		$translateProvider.useSanitizeValueStrategy('sanitize');
	}
    
    translations.$inject=['$translateProvider'];

  	return translations;
});
